// extracted by mini-css-extract-plugin
export default {"page":"gamePage_page__+s7vQ","main":"gamePage_main__o7x0F"};